'use strict';

var isArray = require('./isArray.js');
var pickFromUnion = require('./pickFromUnion.js');

/**
 * Retrieves a property from an object if it exists.
 *
 * This might seem like overkill, but it's handy when you're working with complex union types.
 *
 * @template T - The type of the object from which to retrieve the property.
 * @template K - The key of the property to retrieve.
 * @param {T} props - The object from which to retrieve the property.
 * @param {K | K[]} selection - The key of the property to retrieve.
 * @returns {UnionPropertyValue<T, K> | UnionPropertyValue<T, K>[]} - The property value if it exists.
 */ const maybeGet = (props, selection)=>{
    if (isArray(selection)) return pickFromUnion(props, selection);
    if (!props || typeof props !== 'object') return undefined;
    var _props_selection;
    return props && selection in props ? (_props_selection = props[selection]) != null ? _props_selection : undefined : undefined;
};

module.exports = maybeGet;
